export const ItemsTypes = {
  STUDENT: "student",
}
